import { Component, HostListener, OnInit } from '@angular/core';
import { faFacebookF, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faBars, faCaretDown, faEnvelope, faPhone, faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html'
})
export class ToolbarComponent implements OnInit {

  readonly instagram = faInstagram;
  readonly facebook = faFacebookF;
  readonly twitter = faTwitter;
  readonly mail = faEnvelope;
  readonly phone = faPhone;
  readonly caretDown = faCaretDown;
  readonly menu = faBars;
  readonly menuOpen = faTimes;

  mobileShowMenu = false;

  navbarFixed: boolean = false;

  readonly primaryMenu = [
    {
      label: 'Cursos',
      id: 'courses',
      ref: "https://www.playbots.es/cursos",
      bgHover: 'bg-hover-secondary',
      childs: [{
        label: 'Niños de 5 a 8 años',
        ref: "https://www.playbots.es/cursos",
        bgHover: 'bg-hover-warning',
      }, {
        label: 'Niños de 9 a 12 años',
        ref: "https://www.playbots.es/cursos",
        bgHover: 'bg-hover-warning',
      }, {
        label: 'Niños de 13 a 17 años',
        ref: "https://www.playbots.es/cursos",
        bgHover: 'bg-hover-warning',
      }]
    }, {
      label: 'Centros',
      id: 'centers',
      ref: 'https://www.playbots.es/centros',
      bgHover: 'bg-hover-danger'
    }, {
      label: 'Makerspace',
      id: 'makerspace',
      ref: 'https://www.playbots.es/maker-space',
      bgHover: 'bg-hover-warning'
    }, {
      label: 'Campus',
      id: 'campus',
      ref: 'https://www.playbots.es/campus',
      bgHover: 'bg-hover-warning',
      childs: [{
        label: 'Campus de Semana Santa',
        ref: 'https://www.playbots.es/curso/campus-de-semana-santa',
        bgHover: 'bg-hover-secondary'
      }, {
        label: 'Campus de verano',
        ref: 'https://www.playbots.es/curso/campus-de-verano',
        bgHover: 'bg-hover-secondary'
      }, {
        label: 'Campus de navidad',
        ref: 'https://www.playbots.es/curso/campus-de-navidad',
        bgHover: 'bg-hover-secondary'
      }]
    }, {
      label: 'Extraescolares',
      id: 'extra',
      ref: 'https://www.playbots.es/extraescolares',
      bgHover: 'bg-hover-skyblue'
    }, {
      label: 'Contacto',
      id: 'contact',
      ref: 'https://www.playbots.es/contacto',
      bgHover: 'bg-hover-primary'
    }
  ];

  readonly secondaryMenu = [
    {
      label: 'Presentación',
      ref: 'https://www.playbots.es/presentacion/'
    }, {
      label: 'Código Rosa',
      ref: 'https://www.playbots.es/codigo-rosa/'
    }, {
      label: 'Empleo',
      ref: 'https://www.playbots.es/empleo/'
    }, {
      label: 'Blog',
      ref: 'https://www.playbots.es/blog/'
    }, {
      label: 'Área del Tutor',
      ref: '/'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', ['$event']) onScroll() {
    this.navbarFixed = window.scrollY > 10;
  }

}
